import React, { useEffect, useState } from "react";
import { getAdmins, removeAdmin } from "../../services/adminService";

function RemoveAdmin() {
  const [admins, setAdmins] = useState([]);
  const [filteredAdmins, setFilteredAdmins] = useState([]); // Ensure it's initialized as an array
  const [selectedAdmin, setSelectedAdmin] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ message: "", isError: false });

  // Fetch admins on component mount
  useEffect(() => {
    const fetchAdmins = async () => {
      try {
        const response = await getAdmins();
        const adminList = response.data; // Extract the `data` property
        setAdmins(Array.isArray(adminList) ? adminList : []); // Ensure it's an array
        setFilteredAdmins(Array.isArray(adminList) ? adminList : []); // Ensure it's an array
      } catch (error) {
        console.error("Error fetching admins:", error);
        setToast({ message: "Failed to fetch admins", isError: true });
      }
    };

    fetchAdmins();
  }, []);

  // Handle search functionality
  useEffect(() => {
    const filtered = admins.filter((admin) =>
      admin.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredAdmins(filtered);
  }, [searchTerm, admins]);

  // Handle removing an admin
  const handleRemoveAdmin = async () => {
    if (!selectedAdmin) {
      setToast({ message: "Please select an admin to remove", isError: true });
      return;
    }

    setLoading(true);
    try {
      await removeAdmin(selectedAdmin);
      setToast({ message: "Admin removed successfully", isError: false });
      window.location.reload();

      // Update the admin list after removal
      const updatedAdmins = admins.filter(
        (admin) => admin.id !== selectedAdmin
      );
      setAdmins(updatedAdmins);
      setFilteredAdmins(updatedAdmins);
      setSelectedAdmin("");
    } catch (error) {
      console.error("Error removing admin:", error);
      setToast({ message: "Failed to remove admin", isError: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Remove Admin</h2>

      {/* Dropdown */}
      <select
        value={selectedAdmin}
        onChange={(e) => setSelectedAdmin(e.target.value)}
        className="border p-2 rounded w-full mb-4"
      >
        <option value="">Select an admin</option>
        {Array.isArray(filteredAdmins) &&
          filteredAdmins.map((admin) => (
            <option key={admin.id} value={admin.id}>
              {admin.name}
            </option>
          ))}
      </select>

      {/* Remove Button */}
      <button
        onClick={handleRemoveAdmin}
        className={`bg-red-500 text-white px-4 py-2 rounded ${
          loading ? "opacity-50 cursor-not-allowed" : ""
        }`}
        disabled={loading}
      >
        {loading ? "Removing..." : "Remove Admin"}
      </button>

      {/* Toast Notification */}
      {toast.message && (
        <div
          className={`fixed top-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded shadow z-50 ${
            toast.isError
              ? "bg-red-100 text-red-700"
              : "bg-green-100 text-green-700"
          }`}
        >
          {toast.message}
          <button
            onClick={() => setToast({ message: "", isError: false })}
            className="ml-4 font-bold"
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
}

export default RemoveAdmin;
